/**
 * A component containing a loader.
 * @param {props} Props Component props.
 * @example
 * <BallPulseLoader center={true}/>
 * <BallPulseLoader center={false}/>
 */
const BallPulseLoader = ({ center = false, color = "#fff", style = {} }) => {
	const s = center
		? {
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
				display: "flex",
				...style
		  }
		: style;

	return (
		<div className="ball-pulse" style={s}>
			<div style={{ backgroundColor: color }} />
			<div style={{ backgroundColor: color }} />
			<div style={{ backgroundColor: color }} />
		</div>
	);
};

export default BallPulseLoader;
